<template>
	<div class="main-footer main-footer2 minwidth">
		<div class="blank-ft"></div>
		<div class="copyright2">
			<div class="mx1360 tbd">
				<div class="t">@ 2025 环太湖艺术动产登记备案综合服务平台.</div>
				<div class="t2">Huantaihu Art Movable Asset Registry & Integrated Services Platform All rights reserved.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import util from "@/common/util.js"
export default {
	name: 'myfooter2',
	props: {
		// 外部参数示例
		// data: {
		//     type: Array,
		//     default: () => []
		// },
	},
	data() {
		return {
			// 内部参数
		}
	},
	methods: {
		goPage(id) {
			if (this.$route.name === 'detail') {
				this.$emit("getDetail", id);
			} else {
				util.tourl("/detail", { id: id })
			}
		},
		goDoclist() {
			if (this.$route.name === 'doclist') {
				return
			} else {
				util.tourl("/doclist")
			}
		},
	},
	mounted() {

	}

}
</script>

<style lang="scss" scoped>
@import "./footer2.scss";
</style>